import React, { useEffect, useState } from 'react';
import { GroupListType, GetTrendGroupList } from '../../../function/GroupDataModel';
import { ItemComboBox, ComboBoxItemType } from '../../atoms/ComboBox/ItemComboBox';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(
  createStyles({
    labelStyle: {
      fontSize: '14px',
    },
    itemBoxStyle: {
      fontSize: '15px',
    },
  })
);

//グループリスト作成
const createMeasureList = (data: GroupListType): ComboBoxItemType[] => {
  var ret: ComboBoxItemType[] = [];
  if (data != null) {
    const gpList = data.TM_TRD_GROUP_SETs.filter((r) => r.DSP_FLG == 1);
    for (var i in gpList) {
      ret.push({
        index: gpList[i].GROUP_NO,
        name: `[${gpList[i].GROUP_NO}]` + gpList[i].GROUP_NAME,
      });
    }
  }
  return ret;
};

type Props = {
  onChangeEvent: (event: React.ChangeEvent<{ name?: string; value: unknown }>) => void;
  defalutIndex: number;
};

const TrendGraphPageComboBox: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [groupList, setGroupList] = React.useState<ComboBoxItemType[]>([]);

  useEffect(() => {
    GetTrendGroupList()
      .then((ret) => {
        setGroupList(createMeasureList(ret));
      })
      .catch((reason) => {});
  }, []);

  return (
    <ItemComboBox
      value={props.defalutIndex}
      label={t('TrendGraphPageComboBox.グループ選択', 'グループ選択：')}
      itemList={groupList}
      labelStyle={classes.labelStyle}
      itemBoxStyle={classes.itemBoxStyle}
      onChangeEvent={props.onChangeEvent}
    />
  );
};

export default TrendGraphPageComboBox;
